module.exports = __webpack_public_path__ + "static/media/omegamax6501.28fc8aed.pdf";